import { render, staticRenderFns } from "./uinfo.vue?vue&type=template&id=bdb230ea&scoped=true&"
import script from "./uinfo.vue?vue&type=script&lang=js&"
export * from "./uinfo.vue?vue&type=script&lang=js&"
import style0 from "./uinfo.vue?vue&type=style&index=0&id=bdb230ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb230ea",
  null
  
)

export default component.exports